<aside
    class="flex h-screen flex-col border-r border-transparent bg-gradient-to-b from-[#0284c7] via-[#0f6ebd] to-[#0d9488]"
>
    <!-- Logo -->
    <div class="flex h-18 shrink-0 items-center gap-2 px-4">
        <img
            [routerLink]="['/vendor/overview']"
            [src]="logoSrc()"
            [alt]="logoAlt()"
            class="w-52 cursor-pointer object-contain brightness-0 drop-shadow-md invert transition-all hover:scale-[1.02]"
        />
    </div>

    <!-- Company Identity -->
    <!-- @if (showLabel()) {
        <div
            class="mx-3 mb-4 flex items-center gap-3 rounded-xl bg-slate-800 px-3 py-3"
        >
            <div
                class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-sm font-bold text-slate-900"
                style="
                    background: linear-gradient(
                        135deg,
                        #0f6ebd 0%,
                        #1587e8 50%,
                        #38bdf8 100%
                    );
                "
            >
                {{ companyName().charAt(0) }}
            </div>
            <div class="min-w-0">
                <p class="truncate text-sm font-semibold text-white">
                    {{ companyName() }}
                </p>
                <p class="text-xs text-slate-500">Vendor Account</p>
            </div>
        </div>
    } -->

    <!-- Navigation -->
    <nav class="flex-1 overflow-y-auto px-3 pb-4">
        @for (
            group of navigationGroups();
            track group.label;
            let first = $first
        ) {
            @if (showLabel()) {
                <p
                    class="mb-2 px-3 text-[11px] font-semibold tracking-[0.12em] text-white/70 uppercase"
                    [class.mt-5]="!first"
                >
                    {{ group.label }}
                </p>
            } @else {
                <div class="mx-2 my-3 border-t border-white/20"></div>
            }

            <ul class="space-y-0.5">
                @for (item of group.items; track item.routerLink) {
                    <li>
                        <a
                            [routerLink]="[item.routerLink]"
                            routerLinkActive="nav-item-active"
                            class="nav-item group relative flex items-center gap-3 rounded-xl px-3 py-2.5 text-[14px] font-medium text-white/80 transition-colors duration-150 hover:bg-white/10 hover:text-white"
                            [class.justify-center]="isCollapsed()"
                        >
                            <ng-icon
                                [name]="item.icon!"
                                class="h-[18px] w-[18px] shrink-0"
                            />
                            @if (showLabel()) {
                                <span>{{ item.label }}</span>
                            } @else {
                                <span
                                    class="pointer-events-none absolute left-full z-50 ml-2 hidden rounded-lg bg-slate-800 px-2.5 py-1.5 text-xs font-semibold whitespace-nowrap text-white opacity-0 shadow-lg transition-opacity duration-150 group-hover:opacity-100 lg:block"
                                >
                                    {{ item.label }}
                                </span>
                            }
                        </a>
                    </li>
                }
            </ul>
        }
    </nav>

    <!-- Bottom Section -->
    @if (showLabel()) {
        <div class="shrink-0 border-t border-white/20 px-3 py-3">
            <a
                routerLink="/vendor/settings"
                routerLinkActive="nav-item-active"
                class="nav-item flex items-center gap-3 rounded-xl px-3 py-2.5 text-[14px] font-medium text-white/80 transition-colors duration-150 hover:bg-white/10 hover:text-white"
            >
                <ng-icon
                    name="lucideHelpCircle"
                    class="h-[18px] w-[18px] shrink-0"
                />
                <span>Help & Support</span>
            </a>
        </div>
    }
</aside>
